// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Alert from "src/components/shared/alerts/Alert/Alert";
import OcularMotilityPositionsGraph from "./OcularMotilityPositionsGraph/OcularMotilityPositionsGraph";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Constants
import {
  examCardEnums,
  NINE_GAZE_POSITION_LAYOUT,
  H_PATTERN_POSITION_LAYOUT,
} from "src/constants/enums";

// Utils
import { isTerminatedExamReport } from "src/utils/exams/examReportsHelper";

const OcularMotilityGraph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const isTerminated = useMemo(
    () =>
      isTerminatedExamReport({
        exam,
        examReport,
        sectionName: examCardEnums.OCULAR_MOTILITY.sectionName,
      }),
    [exam, examReport]
  );

  const hPatternResults = useMemo(
    () => examReport?.postProcessing?.hPatternResults,
    [examReport?.postProcessing?.hPatternResults]
  );

  const nineGazeResults = useMemo(
    () => examReport?.postProcessing?.nineGazeResults,
    [examReport?.postProcessing?.nineGazeResults]
  );

  return (
    <Grid container gap="20px">
      {isTerminated && (
        <Alert
          variant="error"
          alertContent={t("Terminated Exam")}
          props={{ width: "100%" }}
        />
      )}

      {hPatternResults && (
        <Grid item xs={12}>
          <OcularMotilityPositionsGraph
            results={hPatternResults}
            cardLayout={H_PATTERN_POSITION_LAYOUT}
          />
        </Grid>
      )}

      {nineGazeResults && (
        <Grid item xs={12}>
          <OcularMotilityPositionsGraph
            results={nineGazeResults}
            cardLayout={NINE_GAZE_POSITION_LAYOUT}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default OcularMotilityGraph;
